<template>
  <section class="column">
    <table-grupos :id="userId" />
    <q-separator style="margin-top: 40px" />

    <table-ferramentas :id="userId" />
  </section>
</template>

<script setup>
import { computed } from "@vue/reactivity";
import { defineProps } from "vue";
import TableGrupos from "./TableGrupos.vue";
import TableFerramentas from "./TableFerramentas.vue";

const props = defineProps({
  id: {
    type: Number,
  },
});

const userId = computed(() => props.id);
</script>

<style></style>
